<template>
    <transition name="toast-fade">
        <div class="toast" v-show="visible">
            {{ message }}
        </div>
    </transition>
</template>

<script>
export default {
    name: "Toast",
    data() {
        return {
            visible: false,
            message: '',
            duration: 1500
        }
    },
    methods: {
        show(message, duration = 1500) {
            this.message = message;
            this.duration = duration;
            this.visible = true;

            setTimeout(() => {
                this.visible = false;
            }, duration);
        }
    }
}
</script>

<style scoped lang="scss">
.toast {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.7);
    color: #ffffff;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 14px;
    z-index: 9999;
    max-width: 80%;
    text-align: center;
    word-wrap: break-word;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
    transition: opacity 0.3s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
    opacity: 0;
}
</style>
